import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { DesktopContainer } from "../layouts";
import { api } from "../utils";

export default function UpsAccountEditor(_props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [accountInfo, setAccountInfo] = useState();
  const [addresses, setAddresses] = useState([]);
  const [activeAddress, setActiveAddress] = useState({});

  useEffect(
    refreshData
    // eslint-disable-next-line react-hooks/exhaustive-deps
  , [id]);

  function handleChange(field, value) {
    const addressCopy = _.clone(activeAddress);
    addressCopy[field] = value;
    setActiveAddress(addressCopy);
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!activeAddress.addressCode) return;

    const payload = {
      AccountId: id,
      AddressCode: activeAddress.addressCode,
      UpsAccount: activeAddress.upsAccount,
    };

    api
      .post(`Customer/SaveUpsAccount`, payload)
      .then((response) => {
        if (response.data.success) {
          refreshData();
          if (_.isString(response?.data?.message)) {
            toast.success(response?.data?.message);
            navigate(-1);
          }
        } else {
          if (_.isString(response?.data?.message)) {
            toast.error(response?.data?.message);
          }
        }
      })
      .catch(api.catchHandler);
  }

  function loadAddress(addressType) {
    const address = _.find(
      addresses,
      (address) => address.addressCode === addressType
    );
    setActiveAddress(address);
  }

  function refreshData() {
    api
      .fetch(`Customer/GetAllAddressInfo/${id}`)
      .then((response) => {
        if (response.data.success) {
          setAccountInfo(response.data.accountInfo);
          setAddresses(response.data.addresses);
        }
      })
      .catch(api.catchHandler);
  }

  return (
    <DesktopContainer screenName={"Edit UPS Account"}>
      <Row className="justify-content-center">
        <Col xs="8">
          <Form onSubmit={handleSubmit}>
            <FormGroup row>
              <Label children={"Customer:"} xs={2} className="fw-bold" />
              <Label children={accountInfo && accountInfo.name} xs={8} />
              <Col xs={2}>
                <Button
                  className="shredButton float-end"
                  children="Back"
                  onClick={() => navigate(-1)}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label children="Address:" xs={2} className="fw-bold" />
              <Col xs={10}>
                <Select
                  classNamePrefix="serviceThreadSelect"
                  id="addressType"
                  options={_.map(addresses, (adr) => {
                    return { value: adr.addressCode, label: adr.ddlText };
                  })}
                  onChange={(opt) => loadAddress(opt.value)}
                />
              </Col>
            </FormGroup>
            <Row className="mb-0">
              <Label children="Address 1:" xs={2} className="fw-bold" />
              <Label children={(activeAddress && activeAddress.address1) || ""} xs={10} />
            </Row>
            <Row className="mb-0">
              <Label children="Address 2:" xs={2} className="fw-bold" />
              <Label children={(activeAddress && activeAddress.address2) || ""} xs={10} />
            </Row>
            <Row className="mb-0">
              <Label children="Address 3:" xs={2} className="fw-bold" />
              <Label children={(activeAddress && activeAddress.address3) || ""} xs={10} />
            </Row>
            <Row className="mb-0">
              <Label children="City:" xs={2} className="fw-bold" />
              <Label children={(activeAddress && activeAddress.city) || ""} xs={10} />
            </Row>
            <Row className="mb-0">
              <Label children="State:" xs={2} className="fw-bold" />
              <Label children={(activeAddress && activeAddress.state) || ""} xs={10} />
            </Row>
            <Row className="mb-0">
              <Label children="Zip Code:" xs={2} className="fw-bold" />
              <Label children={(activeAddress && activeAddress.zip) || ""} xs={10} />
            </Row>
            <Row className="mb-0">
              <Label children="Country:" xs={2} className="fw-bold" />
              <Label children={(activeAddress && activeAddress.countryCode) || ""} xs={10} />
            </Row>
            <FormGroup row>
              <Label children="UPS Account:" xs={2} className="fw-bold" />
              <Col xs={10}>
                <Input
                  id="upsAcct"
                  value={(activeAddress && activeAddress.upsAccount) || ""}
                  onChange={(e) => handleChange("upsAccount", e.target.value)}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Col xs={{ size: 2, offset: 10 }}>
                <Button
                  className="shredButton"
                  style={{ width: "100%" }}
                  type="submit"
                  children="Save"
                />
              </Col>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </DesktopContainer>
  );
}
